import { delay, put } from 'redux-saga/effects';

import { fetchProcessingAggregatesRequest } from '@actions/standardTemplate';

export const pollProcessingAggregatesSaga = function* ({ payload }) {
  while (true) {
    yield delay(1000 * 5); // Debounce
    yield put(fetchProcessingAggregatesRequest(payload));
  }
};
